import { apiFetch } from "../http";
const getErrorMessage = (data, fallback) => {
    if (!data)
        return fallback;
    if (typeof data.errors === "string")
        return data.errors;
    if (data.errors && typeof data.errors === "object") {
        return Object.values(data.errors).join(", ");
    }
    return data.detail || data.error || data.message || fallback;
};
export async function getTravelShareLink(params) {
    const { baseUrl, travelPlanId, token } = params;
    const data = await apiFetch(`/travel/api/travel_share_link/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "GET",
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось получить ссылку для шаринга"));
    }
    return data;
}
export async function upsertTravelShareLink(params) {
    const { baseUrl, travelPlanId, body, token, csrfToken } = params;
    const data = await apiFetch(`/travel/api/travel_share_link/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
        body: JSON.stringify(body),
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось создать ссылку для шаринга"));
    }
    return data;
}
export async function deleteTravelShareLink(params) {
    const { baseUrl, travelPlanId, token, csrfToken } = params;
    const data = await apiFetch(`/travel/api/travel_share_link/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось отключить ссылку для шаринга"));
    }
    return data;
}
export async function getSharedTravelByToken(params) {
    const { baseUrl, tokenValue } = params;
    const data = await apiFetch(`/travel/api/shared_travel/${tokenValue}/`, {
        baseUrl,
        method: "GET",
        redirectOnUnauthorized: false,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Не удалось открыть shared travel"));
    }
    return data;
}
